import {ReactNode} from "react";
import useFormMethods from "@Form/hooks/useFormMethods";
import StaticPageHeaderTitle from "@Pages/stationToStation/features/header/components/StaticPageHeaderTitle";
import Translation from "@Translation/components/Translation";
import useIsMobile from "@Hooks/selector/useIsMobile";

interface FormWrapperProps {
    formVersion?: string
    children: ReactNode,
    displayDescription?: boolean,
}

function FormWrapper({formVersion = "1", children, displayDescription}: FormWrapperProps) {
    const {
        setClassName,
    } = useFormMethods()

    const isMobile = useIsMobile()

    if (formVersion === "2") {
        return (
            <div className="gb--search-2-container gb--search-2-container__outer">
                {displayDescription && (
                    <StaticPageHeaderTitle/>
                )}
                <div className="gb--search-2-container gb--search-2-container__inner">
                    {!isMobile && (
                        <p className="gb--search-2-container__inner-cta">
                            <Translation translationKey="sts_page.form_title"/>
                        </p>
                    )}
                    {children}
                </div>
            </div>
        )
    }

    return (
        <div className={setClassName()}>
            {children}
        </div>
    )
}

export default FormWrapper